import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { IFloorPayload } from "../../../components/FacilityManager/Domain/Types/FloorPlan/FloorPayload.type";

export function useRemoteFetchFloorPlanService(
  floorInventoryId: number,
  start: string,
  end: string | null,
  isEditService: boolean
) {
  /**
   * can convert to mutation by using
   * const url = new URL(`/plan/${floorInventoryId}/services`, window.location.origin);
   * const params = new URLSearchParams({ start, endd });
   * url.search = params.toString();
   */

  const params = { start, end };
  return useRemoteQuery<IFloorPayload>({
    queryKey: ["fetchFloorPlan", floorInventoryId, "service", start, end],
    url: `/plan/${floorInventoryId}/services`,
    params,
    enabled: floorInventoryId != 0 && !isNaN(Date.parse(start)) && isEditService
  });
}
